import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { AppService } from '../../../app.service';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { GtwElementsBaseUrlsModel } from '../../../shared/_models/gtw-elements-base-urls.model';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import {
  buildHeaderDataShell,
  extractObject,
  generalConfigFromGlobal,
  hydratedGlobalParams,
  normalizeFilterParams,
  rowPayloadFromActiveScreen,
} from '../../../shared/workspace-element-context';

@Component({
    selector: 'gtw-data-produce-8858',
    templateUrl: './data-produce-8858.component.html',
    styleUrls: ['./data-produce-8858.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DataProduce8858Component implements OnInit, OnDestroy {
  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  private readonly contextSubs = new Subscription();
  private isInitialized = false;

  baseURLs: GtwElementsBaseUrlsModel = { admin: '', api: '', custom: '', efile: '', pdfEngine: '', bulkPdfEngine: '' };
  globalService: any = {};
  GENERAL_CONFIG: any = {};
  filterParams: any = {};
  rowData: any = {};

  constructor(
    private cdr: ChangeDetectorRef,
    private gtwSnackbarService: GtwSnackbarService,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService
  ) {}

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.tryInit();
    this.contextSubs.add(
      this.gtwWorkspace.setTabActive.subscribe(() => {
        this.applyWorkspaceContext();
        this.tryInit();
      })
    );
    this.contextSubs.add(
      this.gtwGlobal.globalParamsChanged$.subscribe(() => {
        this.applyWorkspaceContext();
        this.tryInit();
      })
    );
  }

  ngOnDestroy(): void {
    this.contextSubs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const shell = buildHeaderDataShell(this.gtwGlobal, this.gtwApp);
    const hydrated = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace) || {};
    let fp = normalizeFilterParams(activeScreen);
    if (!Object.keys(fp).length) {
      fp = extractObject(hydrated);
    }
    this.filterParams = fp;
    const mergedGp = { ...extractObject(shell.globalParams), ...extractObject(hydrated) };
    this.globalService = {
      ...shell,
      globalParams: mergedGp,
      filterParams: fp,
      workspaceFactory: this.gtwWorkspace.workspaceFactory,
      inputs: this.gtwGlobal.inputs,
      sso_id: this.gtwApp?.USER_SETTINGS?.user?.sso_id ?? '',
    };
    const gc = generalConfigFromGlobal(this.gtwGlobal);
    this.GENERAL_CONFIG = { ...gc, base_url: gc.base_url || gc.api || '' };
    this.baseURLs = gc;
    const rawRow = rowPayloadFromActiveScreen(activeScreen);
    this.rowData = Array.isArray(rawRow)
      ? extractObject(rawRow[0]?.data ?? rawRow[0])
      : extractObject(rawRow);
  }

  private tryInit() {
    if (this.isInitialized) return;
    if (!this.GENERAL_CONFIG || Object.keys(this.GENERAL_CONFIG).length === 0) return;
    this.isInitialized = true;
    this.init();
  }

  private init() {
    this.cdr.detectChanges();
  }

  save() {
    this.gtwSnackbarService.openSnackBar('Data save Successfully', 'gtw-snackbar--green');
  }

  cancel() {
    this.requestGridUpdate.emit('cancel');
  }
}
